import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0e231240&scoped=true&"
import script from "./index.component.ts?vue&type=script&lang=ts&"
export * from "./index.component.ts?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=0e231240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e231240",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e231240')) {
      api.createRecord('0e231240', component.options)
    } else {
      api.reload('0e231240', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0e231240&scoped=true&", function () {
      api.rerender('0e231240', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/layout/index.vue"
export default component.exports